import {ViewportModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/viewport/ViewportModel';
import {BaseFieldConverter} from '@mintdata/mint-kit/impl/properties/converters/BaseFieldConverter';

export class ViewportConverter extends BaseFieldConverter<ViewportModel>
{
}
